module.exports = __webpack_public_path__ + "img/logo_cua.df22d229.png";